// Routes that don't depend on the logged user ("me") being loaded
export const PUBLIC_PATHS = [
  "/login",
  "/auth",
  "/logout",
  "/erro",
  "/acesso-negado",
];
